import { mediaUrl } from "@/lib/api";

/** Decode the AUTO/RANGE film playlist embedded as data:application/json,<encoded>. */
export function decodeAutoPlaylist(fileUrl) {
  if (!fileUrl || !fileUrl.startsWith("data:application/json")) return null;
  try {
    const comma = fileUrl.indexOf(",");
    if (comma === -1) return null;
    const payload = decodeURIComponent(fileUrl.slice(comma + 1));
    const parsed = JSON.parse(payload);
    if (Array.isArray(parsed)) {
      return parsed.map((p) => ({ ...p, url: mediaUrl(p.url) }));
    }
  } catch (e) {
    return null;
  }
  return null;
}
